import React, { useCallback, useEffect, useState } from "react";

import { getAuthStatus, saveFormData } from "../utils/api";
import { cleanFields } from "./IntakeForm/fields";

// ui
import Layout from "./Layout";

// intake form
import IntakeForm from "./IntakeForm/IntakeForm";
import IntakeFormSuccess from "./IntakeForm/IntakeFormSuccess";

const App = (props) => {
	const { isInternalUser, applicationConfig, userId } = props;

	// state
	const [isAuth, setIsAuth] = useState(false);
	const [error, setError] = useState(false);
	const [canSave, setCanSave] = useState(false);
	const [isComplete, setIsComplete] = useState(false);

	// add to appConfig
	// We do it this way because applicationConfiguration is a prop that is set
	// by @trp/authentication-component in ../index.js and we cannot override it before
	// sending it as a prop (in the withAuthFlow HOC).
	const getAppConfig = useCallback(() => {
		const apiUrl = isInternalUser
			? applicationConfig.apiUrlInternal
			: applicationConfig.apiUrl;

		return {
			...applicationConfig,
			isInternalUser,
			apiUrl
		};
	}, [applicationConfig, isInternalUser]);

	// componentDidMount hook
	useEffect(() => {
		const checkAuth = async () => {
			try {
				const res = await getAuthStatus({
					appConfig: getAppConfig()
				});

				if (res.validSession) {
					setIsAuth(true);
				}
			} catch (err) {}
		};

		// delay enable form save as spam deterrent
		setTimeout(function() {
			setCanSave(true);
		}, 2000);

		// check to see if user is authorized
		// we only care if external users are authenticated since
		// we require a login for internal users AND if an internal
		// user is filling out the form, the external user is not logged in
		if (!isInternalUser) {
			checkAuth();
		}
	}, [getAppConfig, isInternalUser]);

	// handle form submit
	const handleSubmit = async (values, actions) => {
		// clear error
		setError(false);

		// clean the fields for submit
		const { data, allowSave } = cleanFields({
			values,
			isAuth,
			userId
		});

		if (canSave && allowSave) {
			const res = await saveFormData({
				data,
				appConfig: getAppConfig()
			});

			// display status
			if (res.message) {
				// set state for displaying accepted page
				setIsComplete(true);
				window.scrollTo(0, 0);
			} else {
				// set error
				handleError(res.error);
			}
		} else {
			handleError("There was an error saving the form, please try again.");
		}

		actions.setSubmitting(false);
	};

	// set error and scroll to top
	const handleError = (error) => {
		setError(error);
		window.scrollTo(0, 0);
	};

	return (
		<Layout>
			{isComplete ? (
				<IntakeFormSuccess />
			) : (
				<IntakeForm
					error={error}
					setError={handleError}
					handleSubmit={handleSubmit}
					isInternalUser={isInternalUser}
				/>
			)}
		</Layout>
	);
};

export default App;
